// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-p {
	font-size: 18px;
}
.template-span {
	font-size: 16px;
}
.template-input_wrapper {
	max-width: 160px;
}

.template-input {
	background: white !important;
	border-radius: 3px;
	margin-right: 8px;
	width: 200px;
	min-width: 250px;
	border: 2px solid #b7d423;
	padding: 10px;
}

.template-input-date {
	border: 2px solid #ffce1b;
	padding: 6px 12px;
	border-radius: 3px;
}

.template-input::placeholder {
	color: #b7d423;
}

.html-object-embed::before {
	display: none;
}
.html-object-embed {
	outline: 0 !important;
	padding: 0 !important;
}
.template-hrline {
	background-color: black;
	width: 100%;
	height: 2px;
}
.template-border {
	width: auto;
	display: block;
	border: 2px solid black;
}
.green-circle {
	background-color: #b7d423;
	color: black;

	border-radius: 50%;
	width: 35px;
	height: 35px;
	display: flex;
	justify-content: center;
	align-items: center;
}
.ck-widget.html-object-embed {
	background: transparent !important;
	height: auto;
	min-width: 14px !important;
}
.html-object-embed__content {
	min-width: -webkit-min-content !important;
	min-width: min-content !important;
}

.template-dropdown {
	padding: 10px 20px;

	border: 2px solid #b7d423;
	color: #b7d423;
	background-color: transparent;
}

.template-checkbox {
	width: 100% !important;
}

.template-ui_select {
	padding: 0.8rem 1rem;
	border: 2px solid #b7d423;
	color: #b7d423;
	outline: 0;
	background: transparent;
	border-radius: 8px;
}
.template-ui_select option {
	color: red;
}
.template-esign {
	color: #b4a7d6 !important;
	width: 160px;
	min-width: 160px;
	min-height: 55px;
	margin: 15px 30px;
	border: 1px solid #b4a7d6;
}
.template-esign::placeholder {
	color: #b4a7d6 !important;
}

.template-input-color {
	border: 1px solid #ea9999;
	color: #ea9999 !important;
}
.template-input-color::placeholder {
	color: #ea9999 !important;
}
.template-dropdown-color {
	border: 1px solid #ffe599;
	color: #ffe599 !important;
}
.template-dropdown-color::placeholder {
	color: #ffe599 !important;
}
.template-recipient-input-color {
	border: 1px solid #a4c2f4;
	color: #a4c2f4 !important;
}

.template-recipient {
	margin-top: 20px;
}

.template-recipient-input-color::placeholder {
	color: #a4c2f4 !important;
}
.preview-esign {
	border-color: #b4a7d6 !important;
	color: #b4a7d6 !important;
}
.input-esign {
	min-width: 60px;
}
.no-border {
	border: 0px solid transparent;

	font-size: 14px;
	position: relative;
	bottom: 2px;
	font-family: 'Gilroy-medium', sans-serif;
}
.table-input {
	width: auto !important;
}

.ck.ck-editor__editable_inline > :last-child {
	height: 40px;
}

.required-asterisk {
	position: relative;
	padding-left: 15px !important;
}

.required-asterisk::before {
	content: '* ';
	color: red;
	font-weight: bold;
	position: absolute;
	left: 5px;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
	z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/template.styles.css"],"names":[],"mappings":"AAAA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;CACZ,gBAAgB;CAChB,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,iBAAiB;CACjB,kBAAkB;AACnB;;AAWA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;AACA;CACC,qBAAqB;CACrB,qBAAqB;AACtB;AACA;CACC,uBAAuB;CACvB,WAAW;CACX,WAAW;AACZ;AACA;CACC,WAAW;CACX,cAAc;CACd,uBAAuB;AACxB;AACA;CACC,yBAAyB;CACzB,YAAY;;CAEZ,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,kCAAkC;CAClC,YAAY;CACZ,0BAA0B;AAC3B;AACA;CACC,yCAAiC;CAAjC,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;;CAElB,yBAAyB;CACzB,cAAc;CACd,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;CACpB,yBAAyB;CACzB,cAAc;CACd,UAAU;CACV,uBAAuB;CACvB,kBAAkB;AACnB;AACA;CACC,UAAU;AACX;AACA;CACC,yBAAyB;CACzB,YAAY;CACZ,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,gCAAgC;CAChC,yBAAyB;AAC1B;AACA;CACC,eAAe;AAChB;AACA;CACC,6BAA6B;;CAE7B,eAAe;CACf,kBAAkB;CAClB,WAAW;CACX,wCAAwC;AACzC;AACA;CACC,sBAAsB;AACvB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,UAAU;CACV,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,2BAA2B;CAC3B,oBAAoB;CACpB,UAAU;AACX","sourcesContent":[".template-p {\n\tfont-size: 18px;\n}\n.template-span {\n\tfont-size: 16px;\n}\n.template-input_wrapper {\n\tmax-width: 160px;\n}\n\n.template-input {\n\tbackground: white !important;\n\tborder-radius: 3px;\n\tmargin-right: 8px;\n\twidth: 200px;\n\tmin-width: 250px;\n\tborder: 2px solid #b7d423;\n\tpadding: 10px;\n}\n\n.template-input-date {\n\tborder: 2px solid #ffce1b;\n\tpadding: 6px 12px;\n\tborder-radius: 3px;\n}\n\n.template-input::-webkit-input-placeholder {\n\tcolor: #b7d423;\n\ttext-align: center;\n}\n\n.template-input:-ms-input-placeholder {\n\tcolor: #b7d423;\n}\n\n.template-input::placeholder {\n\tcolor: #b7d423;\n}\n\n.html-object-embed::before {\n\tdisplay: none;\n}\n.html-object-embed {\n\toutline: 0 !important;\n\tpadding: 0 !important;\n}\n.template-hrline {\n\tbackground-color: black;\n\twidth: 100%;\n\theight: 2px;\n}\n.template-border {\n\twidth: auto;\n\tdisplay: block;\n\tborder: 2px solid black;\n}\n.green-circle {\n\tbackground-color: #b7d423;\n\tcolor: black;\n\n\tborder-radius: 50%;\n\twidth: 35px;\n\theight: 35px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n.ck-widget.html-object-embed {\n\tbackground: transparent !important;\n\theight: auto;\n\tmin-width: 14px !important;\n}\n.html-object-embed__content {\n\tmin-width: min-content !important;\n}\n\n.template-dropdown {\n\tpadding: 10px 20px;\n\n\tborder: 2px solid #b7d423;\n\tcolor: #b7d423;\n\tbackground-color: transparent;\n}\n\n.template-checkbox {\n\twidth: 100% !important;\n}\n\n.template-ui_select {\n\tpadding: 0.8rem 1rem;\n\tborder: 2px solid #b7d423;\n\tcolor: #b7d423;\n\toutline: 0;\n\tbackground: transparent;\n\tborder-radius: 8px;\n}\n.template-ui_select option {\n\tcolor: red;\n}\n.template-esign {\n\tcolor: #b4a7d6 !important;\n\twidth: 160px;\n\tmin-width: 160px;\n\tmin-height: 55px;\n\tmargin: 15px 30px;\n\tborder: 1px solid #b4a7d6;\n}\n.template-esign::placeholder {\n\tcolor: #b4a7d6 !important;\n}\n\n.template-input-color {\n\tborder: 1px solid #ea9999;\n\tcolor: #ea9999 !important;\n}\n.template-input-color::placeholder {\n\tcolor: #ea9999 !important;\n}\n.template-dropdown-color {\n\tborder: 1px solid #ffe599;\n\tcolor: #ffe599 !important;\n}\n.template-dropdown-color::placeholder {\n\tcolor: #ffe599 !important;\n}\n.template-recipient-input-color {\n\tborder: 1px solid #a4c2f4;\n\tcolor: #a4c2f4 !important;\n}\n\n.template-recipient {\n\tmargin-top: 20px;\n}\n\n.template-recipient-input-color::placeholder {\n\tcolor: #a4c2f4 !important;\n}\n.preview-esign {\n\tborder-color: #b4a7d6 !important;\n\tcolor: #b4a7d6 !important;\n}\n.input-esign {\n\tmin-width: 60px;\n}\n.no-border {\n\tborder: 0px solid transparent;\n\n\tfont-size: 14px;\n\tposition: relative;\n\tbottom: 2px;\n\tfont-family: 'Gilroy-medium', sans-serif;\n}\n.table-input {\n\twidth: auto !important;\n}\n\n.ck.ck-editor__editable_inline > :last-child {\n\theight: 40px;\n}\n\n.required-asterisk {\n\tposition: relative;\n\tpadding-left: 15px !important;\n}\n\n.required-asterisk::before {\n\tcontent: '* ';\n\tcolor: red;\n\tfont-weight: bold;\n\tposition: absolute;\n\tleft: 5px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tpointer-events: none;\n\tz-index: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
